import React from 'react';
import { Navigate } from 'react-router-dom';
import { isHubSession, sessionEndedPath } from '../utils/hubSession';

/**
 * Where a page sends someone who isn't signed in: the session-ended screen for people who came
 * from One Manager (they have no password here; it offers a button back there), otherwise this
 * app's login page.
 */
export default function SignedOutRedirect({ from }) {
  if (isHubSession()) return <Navigate to={sessionEndedPath('no-session')} replace />;
  return <Navigate to="/login" state={from ? { from } : undefined} replace />;
}
